import { Injectable } from "@angular/core";
import { IID_FEASABILITY_CONNECTION_REQUEST } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDConnectionRequestStore } from "./iidConnectionRequest.store";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";
import { InterfaceDataQuery } from "../interfaceDataRegistry";

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.IID_FEASABILITY_CONNECTION_REQUEST)
export class IIDConnectionRequestQuery extends AbstractInterfaceDataQuery<IID_FEASABILITY_CONNECTION_REQUEST> {
  constructor(protected store: IIDConnectionRequestStore) {
    super(store);
  }
}
